import { type AxiosResponse } from 'axios';
import HttpClient from '../HttpClient';
import { type LanguageResponseType } from './model';

class LanguageService {
  private httpBokaCoworker: HttpClient;

  public constructor(httpBokaCoworker: HttpClient) {
    this.httpBokaCoworker = httpBokaCoworker;
  }

  public getLanguagesForCountryCode = async (
    countryCode: string,
  ): Promise<AxiosResponse<LanguageResponseType>> => {
    return this.httpBokaCoworker.get(`/country/${countryCode}`);
  };
}

export default LanguageService;
